import { initReactI18next } from "react-i18next";

import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import { safeGetItem } from "@/utils/safeStorage";

// Get saved language from localStorage, fallback to 'es'
const getSavedLanguage = (): string => {
	if (typeof window !== "undefined") {
		return safeGetItem("i18nextLng") || "es";
	}
	return "es";
};

i18n
	.use(HttpBackend)
	.use(initReactI18next)
	.init({
		lng: getSavedLanguage(),
		fallbackLng: "es",
		supportedLngs: ["en", "es"],
		ns: [
			"common",
			"auth",
			"profile",
			"calendar",
			"propiedades",
			"hipotecas",
			"pricing",
			"financials",
			"valuations",
			"config",
			"dashboard",
			"tour",
		],
		defaultNS: "common",
		backend: {
			loadPath: "/locales/{{lng}}/{{ns}}.json",
			// Prevent caching to ensure fresh translations are loaded
			requestOptions: {
				cache: "no-store",
			},
		},
	});

export default i18n;
